// Shared utility functions for lease key generation
// Used consistently across map, summary, and filter logic

/**
 * Generate consistent lease keys in District-Lease# format
 * @param {string|number} district - District number
 * @param {string|number|null} leaseNumber - Lease number
 * @param {string|null} leaseName - Lease name (used as fallback)
 * @returns {string} Lease key in format: "08-12345" or "08-Unknown Lease-NAME" or "08-Unknown Lease"
 */
export const generateLeaseKey = (district, leaseNumber, leaseName) => {
  const dist = district || '00';
  const num = leaseNumber ? (typeof leaseNumber === 'string' ? leaseNumber.trim() : String(leaseNumber)) : null;
  const name = leaseName ? (typeof leaseName === 'string' ? leaseName.trim() : String(leaseName)) : null;
  
  if (num && num !== 'Unknown Lease' && num !== '') {
    // Normal case: District-LeaseNumber
    return `${String(dist).padStart(2, '0')}-${num}`.toUpperCase();
  } else if (name && name !== 'Unknown Lease' && name !== '') {
    // Missing lease number but have lease name: District-Unknown Lease-LeaseName
    return `${String(dist).padStart(2, '0')}-Unknown Lease-${name.toUpperCase()}`;
  } else {
    // Both missing: District-Unknown Lease
    return `${String(dist).padStart(2, '0')}-Unknown Lease`;
  }
};

/**
 * Format lease number for display (clean format)
 * @param {string|number} district - District number
 * @param {string|number|null} leaseNumber - Lease number
 * @returns {string} Display format: "08-12345" or "08-00000"
 */
export const formatLeaseNumberForDisplay = (district, leaseNumber) => {
  const dist = district || '00';
  const num = leaseNumber ? (typeof leaseNumber === 'string' ? leaseNumber.trim() : String(leaseNumber)) : null;
  
  if (num && num !== 'Unknown Lease' && num !== '') {
    // Normal case: District-LeaseNumber
    return `${String(dist).padStart(2, '0')}-${num}`.toUpperCase();
  } else {
    // Unknown lease: District-00000
    return `${String(dist).padStart(2, '0')}-00000`;
  }
};



